module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addedToCartModal"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.$t('waresAddedToCart')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }, [_c('loader', {
    attrs: {
      "loading": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message raleway"
  }, [_vm._v(" " + _vm._s(_vm.$t('proceedingToCheckout')) + "   ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26d5733a!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Modals/Content/AddedToCart.vue
// module id = 152
// module chunks = 0